<app-dialog
  #dialog
  [key]="'modal-company-benchmark'"
  [action]="'company-benchmark'"
  [headerTheme]="'simple'"
  [title]="'Benchmark da Empresa'"
  [maxWidth]="'600px'">
  <div class="benchmark-modal">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <p-progressSpinner></p-progressSpinner>
      <p>Carregando informações do benchmark...</p>
    </div>

    <!-- Form Content -->
    <div *ngIf="!isLoading">
      <!-- Company Information -->
      <div class="company-info" *ngIf="company">
        <div class="company-header">
          <h3 class="company-name">{{ company.displayName }}</h3>
          <span class="company-cnpj" *ngIf="company.cnpj">CNPJ: {{ company.cnpj }}</span>
        </div>
      </div>

      <!-- Benchmark Form -->
      <form [formGroup]="benchmarkForm" appAutoFormGroup class="benchmark-form">
        <div class="form-section">
          <h4 class="section-title">Configuração do Benchmark</h4>

          <div class="form-group">
            <app-select
              [controlName]="benchmarkFormProps.indexer"
              [label]="'Indexador'"
              [placeholder]="'Selecione o indexador'"
              [options]="indexerOptions">
            </app-select>
          </div>

          <div class="form-group">
            <app-input
              [type]="'number'"
              [controlName]="benchmarkFormProps.percentage"
              [label]="'Spread (%)'"
              [placeholder]="'0,00'"
              [totalFractionDigits]="2"
              [required]="true"
              [min]="0"
              [max]="100">
            </app-input>
            <small class="form-help">Ex: CDI+4% (CDI + 4% a.a.)</small>
          </div>

          <!-- Preview do Benchmark -->
          <div class="benchmark-preview" *ngIf="benchmarkForm.valid">
            <div class="preview-card">
              <i class="pi pi-info-circle"></i>
              <div class="preview-content">
                <strong>Preview:</strong>
                <span class="preview-text">
                  {{ getSelectedIndexerLabel() }} + {{ getPercentageValue() }}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        [type]="'button'"
        theme="white"
        (sendButtonClick)="closeModal()" />

      <app-button
        [label]="isLoading ? 'Salvando...' : isEditMode ? 'Atualizar' : 'Salvar'"
        [type]="'button'"
        [disabled]="!isFormValid() || isLoading"
        [isLoading]="isLoading"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
